module.exports = __webpack_public_path__ + "media/images/yellow_star_full-36b83919a7d21542e614bf04403d7d5a.svg";